import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SwooshComponent } from 'src/app/common/ui-elements/swoosh.component';
import { AppService } from '../../../app.service';
import { ContentService } from '../../../services/content.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-team-teaminsights-problem-solving',
  templateUrl: './team-teaminsights-problem-solving.component.html',
  styleUrls: ['./team-teaminsights-problem-solving.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
   imports: [SwooshComponent, CommonModule],
})
export class TeamInsightsProblemSolvingComponent implements OnInit {
  swooshText = '';
  swooshRoute = '/team';
  swooshFragment = 'TeamInsights';
  @Input() mbtiType: string;
  isApiDataLoaded: boolean = false;
  reportContent: string;

  constructor(
    private appService: AppService,
    private contentService: ContentService,
  ) {}

  ngOnInit() {
    let yourMbtiType = this.appService.mbtiType;
    let reportVariables = 'team-type=' + this.appService.getTeamInfo().teamMbtiType;

    /* See the compile.directive.ts file for how to parse Angular from Roadrunner  */
    this.contentService.getReport('TeamProblemSolvingStyles', yourMbtiType, [], reportVariables).subscribe((data) => {
      let content = data.content.replaceAll('\\"', '\"');
      this.reportContent = content;
      this.isApiDataLoaded = true;
    });
  }
}
